<script lang="ts">
    import LasersheetInput from "../widgets/lasersheet/LasersheetInput.svelte"
    import ProductMainImage from "./productImage/ProductMainImage.svelte"
    import { _ } from "svelte-i18n"
    import { overlay, lasersheetEngraving } from "../../../../store"
    import { isLasersheetConfigValid } from "../widgets/helper"

    let { product, setActiveImage }: { product: Product; setActiveImage: (idx: number) => void } = $props()

    // Validierung: Prüfen ob mindestens ein Feld ausgefüllt ist
    let isValid = $derived.by(() => {
        if (!product.lasersheet_configurator?.length) return true

        const activeLasersheets = product.lasersheet_configurator.map((s) => s.lasersheet_nr)
        return isLasersheetConfigValid($lasersheetEngraving, activeLasersheets)
    })

    function closeOverlay() {
        $overlay.show = false
    }
</script>

<section>
    <ProductMainImage image={product.images[0]} {product} shadow={true} />
    <LasersheetInput {product} {setActiveImage} />
    {#if !isValid}
        <div class="error-message" role="alert" aria-live="polite">
            {$_("product.tooltip-configure-lasersheet")}
        </div>
    {/if}
    <button class="button primary" onclick={closeOverlay} disabled={!isValid}>
        {$_("options.confirm-selection")}
    </button>
</section>

<style lang="less">
    @import "../../../../css/variables.less";
    section {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        padding-bottom: 2rem;

        .error-message {
            background-color: var(--color-error-background, #ffebee);
            color: var(--color-error-text, #c62828);
            padding: 0.8rem 1.2rem;
            border-radius: 4px;
            font-size: 0.9rem;
            text-align: center;
        }

        .button.primary {
            width: 100%;
            margin-top: 1rem;
        }
    }
</style>
